import { FeedTag } from "@routes/Keyword/utils/types";

export enum KeywordType {
  listing = "listing",
  withTag = "with_tag",
  default = "default",
  noTag = "no_tag",
}

export interface KeywordTypeFactoryProps extends IndividualKeywordType {
  keywordType?: KeywordType;
}

export type IndividualKeywordType = {
  tagDisplayName: string;
  tagClassName?: string;
  handleClick?: () => void;
  disableBorder?: boolean;
  tag: FeedTag;
  /** Ref code to be added on the tag links. */
  refCode?: string;
};

export type KeywordLimitModalProps = {
  // Function to close the modal
  onClose: () => void;
  // Flag to control modal visibility
  isModalOpen: boolean;
};
